import {useDispatch,useSelector} from "react-redux";
import {Navigate, Outlet, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import moment from 'moment';
import {SESSION_TIME} from "../utils/config";
import authService from "../services/authService";
import {RootState} from "../store"
import { setOTPVerified, setUser, setSessionTime, setOtpData } from "../slices/authReducer";

export const RequireAuth = () => {

    const { isLoggedIn, sessionTime ,data} = useSelector((state:RootState) => state.authUser);
    let location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    
    // Add loading state to prevent premature redirects
    const [isCheckingAuth, setIsCheckingAuth] = useState(true);

    useEffect(() => {
        const checkAuthentication = () => {
            // Check if we have authentication data in localStorage but Redux isn't updated
            const userData = localStorage.getItem('user-data');
            const authToken = localStorage.getItem('dock_universal_token');
            
            if (!isLoggedIn && userData && authToken) {
                try {
                    const parsedUserData = JSON.parse(userData);
                    
                    // Update Redux state with the stored authentication data
                    dispatch(setUser({
                        ...parsedUserData,
                        user_id: parsedUserData.user_id || parsedUserData.id,
                        user_name: parsedUserData.name || parsedUserData.user_name,
                        mobile: parsedUserData.mobile || parsedUserData.ph,
                        ssoToken: parsedUserData.sso_token,
                        mpin_enabled: parsedUserData.mpin_enabled || false,
                    }));
                    
                    // Set session time
                    const sessionExpiry = moment().add(SESSION_TIME, 'minutes').valueOf();
                    dispatch(setSessionTime(sessionExpiry));
                    
                    // Set additional data
                    dispatch(setOtpData({
                        data: parsedUserData,
                        user_id: parsedUserData.user_id || parsedUserData.id
                    }));
                } catch (error) {
                    console.error('Error parsing stored user data:', error);
                }
            }
            
            // Set loading to false after checking
            setIsCheckingAuth(false);
        };

        checkAuthentication();
    }, [isLoggedIn, dispatch]);

    function checkSession() {
        var now = moment();
        var momentInTime = moment(sessionTime)
        var diff =  now.diff(momentInTime, 'minutes')
        if(diff > 0){
            if(data != undefined &&  data.mfaType=='qr'){
                handleLogout()
            }else{
                if(!localStorage.getItem("PERSIST_OBJECT")){
                    if (searchParams.get('applicationId')) {
                        return;
                    }
                    else{
                        dispatch(authService.logout());
                        localStorage.removeItem("useRefresh");
                        navigate('/',{state:{type:location.pathname},replace: true})
                    }
                }else{
                    dispatch(setOTPVerified())
                    localStorage.setItem("useRefresh", "true");
                    navigate('/Mpin',{state:{type:location.pathname},replace: true})
                }
                
            }
        }
    }

    useEffect(() => {
        if(isLoggedIn && !isCheckingAuth){
            checkSession()
        }
    },[isLoggedIn, isCheckingAuth])

    const handleLogout = () => {
        dispatch(authService.logout())
        navigate("/qrLogin",{ replace: true});
    }

    // Show loading while checking authentication
    if (isCheckingAuth) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                flexDirection: 'column'
            }}>
                <h2>Loading...</h2>
                <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    if (!isLoggedIn) {
        // Check if we still have valid tokens in localStorage
        const userData = localStorage.getItem('user-data');
        const authToken = localStorage.getItem('dock_universal_token');
        
        if (!userData || !authToken) {
            // No valid authentication, redirect to SSO
            return <Navigate to="/tvTerminal/sso" state={{ from: location }} replace />;
        }
        
        // If we have tokens but Redux state isn't updated yet, wait a bit more
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                flexDirection: 'column'
            }}>
                <h2>Authenticating...</h2>
                <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    return <Outlet />;
}